import clsx from "clsx";
import React from "react";
import styles from "./size-pills.module.css";

export interface SizePill {
    id?: string;
    url: string;
    label: string;
    checked: boolean;
    className?: string;
    onClick: () => void;
}

interface SizePillsProps {
    pills: SizePill[];
    className?: string;
}

export function SizePills({ pills, className }: SizePillsProps): JSX.Element {
    return (
        <ul className={clsx(styles.wrapper, className)}>
            {pills.map((pill) => {
                const isLongLabel = pill.label.length > 7;
                return (
                    <li
                        key={pill.id}
                        className={clsx(
                            styles.sizePill,
                            {
                                [styles.selected]: pill.checked,
                                [styles.longLabel]: isLongLabel,
                            },
                            pill.className
                        )}
                    >
                        <a
                            role="menuitemcheckbox"
                            aria-checked={pill.checked}
                            href={pill.url}
                            onClick={(event) => {
                                event.preventDefault();
                                pill.onClick();
                            }}
                        >
                            {pill.label}
                        </a>
                    </li>
                );
            })}
        </ul>
    );
}
